import React from 'react';

import HeaderSimple from 'components/header-simple';
import { Page } from 'components/layouts';
import Button from 'components/button';
import RichText from 'components/rich-text';

import text from './txt';
import './style.css';

const TermsOfService = () => {
  return (
    <Page
      className="page -terms-of-service"
      header={false}
      footer={false}
      theme="white"
    >
      <HeaderSimple>
        <Button hierarchy="tertiary" shadow={false} href="/" className="route">
          Dashboard
        </Button>
      </HeaderSimple>
      <h2 className="terms-of-service-title">Terms Of Service</h2>
      <div className="terms-of-service-wrapper">
        <RichText text={text} />
      </div>
    </Page>
  );
};

export default TermsOfService;
